import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
    AlertDialogTrigger,
  } from "@/Components/ui/alert-dialog";

interface ShowAlertDialogProps {
    title: string
    message: string
    action: () => void
    children?: React.ReactNode
    cancelled?: (cancelled : boolean) => void
}

function ShowAlertDialog({title, message, action, children, cancelled} : ShowAlertDialogProps) {

    return (
    <AlertDialog>
        <AlertDialogTrigger asChild>
            {children}
      </AlertDialogTrigger>
        <AlertDialogContent>
        <AlertDialogHeader>
            <AlertDialogTitle>{title}</AlertDialogTitle>
            <AlertDialogDescription>
            {message}
            </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
            <AlertDialogCancel onClick={() => {cancelled && cancelled(true)}}>Cancel</AlertDialogCancel>
            <AlertDialogAction onClick={action}>Continue</AlertDialogAction>
        </AlertDialogFooter>
        </AlertDialogContent>
    </AlertDialog>
  );
}

export default ShowAlertDialog;